import { useEffect, useRef } from 'react';
import {
	Editor,
	EditorProvider,
	Toolbar,
	BtnBold,
	BtnBulletList,
	BtnClearFormatting,
	BtnItalic,
	BtnLink,
	BtnNumberedList,
	BtnRedo,
	BtnStrikeThrough,
	BtnStyles,
	BtnUnderline,
	BtnUndo,
	HtmlButton,
	Separator,
} from 'react-simple-wysiwyg';

const RichEditor = ({ defaultValue, label, onChange }) => {

	const editorRef = useRef<HTMLDivElement>(null);

	const handleEditorChange = (e) => {
		const dirty = e.target.value;
		const parser = new DOMParser();
		const doc = parser.parseFromString(dirty, 'text/html');

		doc.querySelectorAll('[style]').forEach((el) => {
			const style = el.getAttribute('style') || '';
			const cleaned = style
				.split(';')
				.filter(rule => !rule.trim().startsWith('font-family'))
				.join(';');
			if (cleaned.trim()) {
				el.setAttribute('style', cleaned);
			} else {
				el.removeAttribute('style');
			}
		});

		const cleanedHTML = doc.body.innerHTML;

		// onChange(cleanedHTML)
		onChange(cleanedHTML);
	};

	// Inject Poppins into iframe once it loads
	useEffect(() => {
		const interval = setInterval(() => {
			const iframe = editorRef.current?.querySelector('iframe');
			if (iframe && iframe.contentDocument && iframe.contentDocument.body) {
				iframe.contentDocument.head.innerHTML += `
					<style>
						body {
							font-family: 'Poppins', sans-serif !important;
							font-size: 16px !important;
							lineHeight: 26px !important;
							color: #000 !important;
						}
						* {
							font-family: 'Poppins', sans-serif !important;
						}
					</style>
				`;
				clearInterval(interval);
			}
		}, 300);

		return () => clearInterval(interval);
	}, []);

	return (
		<div>
			<label>{label}</label>
			<EditorProvider>
				<Editor value={defaultValue} onChange={handleEditorChange} style={{
					fontSize: '16px',
					lineHeight: '26px',
					fontFamily: 'Poppins, sans-serif',
					color: '#000'
				}}>
					<Toolbar>
						<BtnUndo />
						<BtnRedo />
						<Separator />
						<BtnBold />
						<BtnItalic />
						<BtnUnderline />
						<BtnStrikeThrough />
						<Separator />
						<BtnNumberedList />
						{/* <BtnBulletList /> */}
						<Separator />
						{/* <BtnLink /> */}
						<BtnClearFormatting />
						{/* <HtmlButton /> */}
						{/* <Separator /> */}
						{/* <BtnStyles /> */}
					</Toolbar>
				</Editor>
			</EditorProvider>
		</div>
	);
};

export default RichEditor;
